<template>
    <div class="mb-4 overflow-hidden rounded-lg border border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800">
        <!-- Loading skeleton -->
        <div v-if="loading" class="grid auto-cols-fr grid-flow-col divide-x divide-gray-100 dark:divide-gray-700/50">
            <div v-for="n in 5" :key="n" class="animate-pulse px-5 py-3">
                <div class="mb-2 h-2 w-16 rounded bg-gray-200 dark:bg-gray-700" />
                <div class="h-4 w-24 rounded bg-gray-200 dark:bg-gray-700" />
            </div>
        </div>

        <!-- Balance grid -->
        <div v-else class="grid auto-cols-fr grid-flow-col divide-x divide-gray-100 overflow-x-auto dark:divide-gray-700/50">
            <div class="min-w-[140px] px-5 py-3">
                <div class="text-xs text-gray-500 dark:text-gray-400">Disponível</div>
                <div class="mt-1 flex items-center gap-1.5">
                    <span class="font-mono text-lg font-semibold tracking-tight text-gray-900 dark:text-white">
                        {{ $root.formatCurrency(balance.available_balance) }}
                    </span>
                    <CheckCircleIcon
                        v-if="balance.available_balance == payables.available"
                        class="h-4 w-4 text-emerald-500"
                    />
                </div>
            </div>

            <div v-if="user.setting.balance_reserve_enabled" class="min-w-[140px] px-5 py-3">
                <div class="flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400">
                    Reservado
                    <InformationCircleIcon
                        class="h-3 w-3"
                        v-tooltip="'Saldo temporariamente reservado conforme configuração'"
                    />
                </div>
                <div class="mt-1 font-mono text-lg font-semibold tracking-tight text-amber-600 dark:text-amber-400">
                    {{ $root.formatCurrency((payables && payables.reserved) || 0) }}
                </div>
            </div>

            <div class="min-w-[140px] px-5 py-3">
                <div class="text-xs text-gray-500 dark:text-gray-400">Antecipação</div>
                <div class="mt-1 font-mono text-lg font-semibold tracking-tight text-gray-900 dark:text-white">
                    {{ $root.formatCurrency(balance.anticipation_balance) }}
                </div>
            </div>

            <div class="min-w-[140px] px-5 py-3">
                <div class="text-xs text-gray-500 dark:text-gray-400">Em análise</div>
                <div class="mt-1 font-mono text-lg font-semibold tracking-tight text-gray-900 dark:text-white">
                    {{ $root.formatCurrency(payables.under_review) }}
                </div>
            </div>

            <div class="min-w-[140px] px-5 py-3">
                <div class="text-xs text-gray-500 dark:text-gray-400">Pendente</div>
                <div class="mt-1 flex items-center gap-1.5">
                    <span class="font-mono text-lg font-semibold tracking-tight text-gray-900 dark:text-white">
                        {{ $root.formatCurrency(balance.pending_balance) }}
                    </span>
                    <CheckCircleIcon
                        v-if="balance.pending_balance == payables.pending"
                        class="h-4 w-4 text-emerald-500"
                    />
                </div>
            </div>

            <div class="min-w-[140px] px-5 py-3">
                <div class="flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400">
                    Total
                    <InformationCircleIcon
                        class="h-3 w-3"
                        v-tooltip="'Disponível + Pendente'"
                    />
                </div>
                <div class="mt-1 font-mono text-lg font-semibold tracking-tight text-gray-900 dark:text-white">
                    {{ $root.formatCurrency(balance.available_balance + balance.pending_balance) }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { CheckCircleIcon, InformationCircleIcon } from "@heroicons/vue/20/solid";
import { mapWritableState } from "pinia";
import { Store } from "../../stores/store";

export default {
    components: { CheckCircleIcon, InformationCircleIcon },
    props: ["user", "wallet"],

    data() {
        return {
            loading: false,
            balance: {
                available_balance: 0,
                pending_balance: 0,
                anticipation_balance: 0,
            },
            pending_records: 0,
            payables: {},
        };
    },

    computed: {
        ...mapWritableState(Store, ["userPendingRecords"]),
    },

    watch: {
        wallet: {
            handler(newWallet) {
                const newWalletId = newWallet?.uuid || newWallet?.id;
                if (newWallet && newWalletId) {
                    this.fetch();
                }
            },
            immediate: false,
        },
    },

    mounted() {
        if (this.wallet) {
            this.fetch();
        }
    },
    methods: {
        fetch() {
            const walletId = this.wallet?.uuid || this.wallet?.id;
            if (!walletId) {
                this.loading = false;
                return;
            }

            this.userPendingRecords = 0;
            this.loading = true;
            axios
                .get(`/api/user/${this.user.id}/wallet/${walletId}/balance`)
                .then(({ data }) => {
                    const incomingBalance = data.balance;
                    this.balance =
                        incomingBalance && typeof incomingBalance === "object"
                            ? incomingBalance
                            : this.balance;
                    this.userPendingRecords = data.pending_records;
                    this.payables = data.payables || {};
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
